import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import moment from 'moment';
import { useTheme } from '@material-ui/core/styles';

import { adverDetailStatistics } from 'lib/api/report';
import {
  makeRowColumn,
  getHeadObj,
  dataConverter,
  converCalFlagData,
  conversionParams,
} from 'lib/commonLib';
import VariousCell from 'components/molecules/MbTable/VariousCell';
import InfoTitleArea from 'components/molecules/MbTable/InfoTitleArea';

import NewButton from 'components/molecules/NewButton';
import TableBtnWrap from 'components/molecules/TableBtnWrap';
import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import FilterCollection from 'components/organisms/FilterCollection';

const DetailStatistics = (props) => {
  const { location, storeCommon, storeAllProductCodeList, rtbDayPlatformList } =
    props;
  const { t } = useTranslation();
  const theme = useTheme();

  //키워드통계 - 지출금액 (adverIds)
  // const { mediaScriptNo, adverIds } = queryString.parse(location.search);
  const locationSearch = queryString.parse(location.search);

  let initParams = {
    sort: 'desc',
    order: 'ADVRTS_AMT',
    sDate: moment().format('YYYYMM01'),
    eDate: moment().format('YYYYMMDD'),
    pltfomTpCode: 'all',
  };

  const convertKeys = [
    'sDate',
    'eDate',
    'mediaScriptNo',
    'adverIds',
    //
    'advrtsPrdtCode',
    'advrtsTpCode',
    'pltfomTpCode',
    'itlTpCode',
    'adverId',
    'adverIds',
    'uri',
    'isPop',
  ];

  let newInitParams = dataConverter(
    queryString.parse(location.search),
    convertKeys
  );
  // if (!!newInitParams['isPop']) {
  //   delete newInitParams['isPop'];
  //   newInitParams['table'] = 'popup';
  // }
  initParams = { ...initParams, ...newInitParams };

  let initCustomized = {
    MANAGE_ICONS: {
      makeHead: (headsMap) => {
        return t('관리');
      },
      makeBody: (rowObj, headsMap) => {
        return (
          rowObj['FIXED'] !== 0 && (
            <TableBtnWrap>
              <NewButton
                title={t('사이트로 이동')}
                iconBtn
                icon="faHome"
                disableRipple
                onClick={() =>
                  window.open('https://' + rowObj['HOME_URL'], '_blank')
                }
              />
            </TableBtnWrap>
          )
        );
      },
    },
    ADVER_NAME: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'ADVER_NAME');
        return rowObj['FIXED'] !== 0
          ? makeRowColumn(
              rowObj['ADVER_NAME'],
              bodyItem1.type,
              bodyItem1.format
            )
          : t('합계');
      },
    },
    HOME_URL: { merged: true },
    ECPM: {
      makeHead: (headsMap) => {
        return (
          <>
            {getHeadObj(headsMap, 'ECPM').label}
            <br />
            {getHeadObj(headsMap, 'TOT_ECPM').label}
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'ECPM');
        const bodyItem2 = getHeadObj(headsMap, 'TOT_ECPM');
        return (
          <>
            {makeRowColumn(rowObj['ECPM'], bodyItem1.type, bodyItem1.format)}
            <br />(
            {makeRowColumn(
              rowObj['TOT_ECPM'],
              bodyItem2.type,
              bodyItem2.format
            )}
            )
          </>
        );
      },
    },
    TOT_ECPM: { merged: true },
    TRGT_ECPM: {
      makeHead: (headsMap) => {
        return {
          content: (
            <InfoTitleArea
              title={t('테이블쇼핑타이틀', {
                label: getHeadObj(headsMap, 'ECPM').label,
              })}
              tooltipTitle={t('테이블쇼핑툴팁ECPM')}
              iconType="fainfoCircle"
            />
          ),
        };
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'ECPM');
        const bodyItem2 = getHeadObj(headsMap, 'TRGT_ECPM');
        return (
          <>
            {makeRowColumn(rowObj['ECPM'], bodyItem1.type, bodyItem1.format)}
            <br />(
            {makeRowColumn(
              rowObj['TRGT_ECPM'],
              bodyItem2.type,
              bodyItem2.format
            )}
            )
          </>
        );
      },
      bodyStyle: { color: theme.palette.common.green },
    },
    TOT_CLICK_RATE: {
      makeHead: (headsMap) => {
        return t('클릭률');
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'TOT_CLICK_RATE');
        return makeRowColumn(
          rowObj['TOT_CLICK_RATE'],
          bodyItem1.type,
          bodyItem1.format
        );
      },
      bodyStyle: { color: theme.palette.common.blue },
    },
    CLICK_RATE: {
      makeHead: (headsMap) => {
        return t('구좌클릭률');
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'CLICK_RATE');
        return makeRowColumn(
          rowObj['CLICK_RATE'],
          bodyItem1.type,
          bodyItem1.format
        );
      },
    },
    MOB_SESSION_ROAS: {
      makeHead: (headsMap) => {
        return {
          content: (
            <InfoTitleArea
              title={t('테이블쇼핑타이틀', {
                label: getHeadObj(headsMap, 'MOB_SESSION_ORDER_AMT').label,
              })}
              tooltipTitle={t('테이블쇼핑툴팁MOB_SESSION_ORDER_AMT')}
              iconType="fainfoCircle"
            />
          ),
        };
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'MOB_SESSION_ROAS');
        const bodyItem2 = getHeadObj(headsMap, 'TRGT_MOB_SESSION_ROAS');
        const bodyItem3 = getHeadObj(headsMap, 'MOB_SESSION_ORDER_AMT');
        return (
          <VariousCell
            type="TRGT"
            bold
            item1={makeRowColumn(
              converCalFlagData('MOB_SESSION_ROAS', headsMap, rowObj),
              bodyItem1.type,
              bodyItem1.format
            )}
            item2={makeRowColumn(
              converCalFlagData('TRGT_MOB_SESSION_ROAS', headsMap, rowObj),
              bodyItem2.type,
              bodyItem2.format
            )}
            item3={makeRowColumn(
              rowObj['MOB_SESSION_ORDER_AMT'],
              bodyItem3.type,
              bodyItem3.format
            )}
          />
        );
      },
    },
    TRGT_MOB_SESSION_ROAS: { merged: true },
    MOB_SESSION_ORDER_AMT: { merged: true },
    BROWSER_SESSION_ROAS: {
      makeHead: (headsMap) => {
        return {
          content: (
            <InfoTitleArea
              title={t('테이블쇼핑타이틀', {
                label: getHeadObj(headsMap, 'BROWSER_SESSION_ORDER_AMT').label,
              })}
              tooltipTitle={t('테이블쇼핑툴팁BROWSER_SESSION_ORDER_AMT')}
              iconType="fainfoCircle"
            />
          ),
        };
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'BROWSER_SESSION_ROAS');
        const bodyItem2 = getHeadObj(headsMap, 'TRGT_BROWSER_SESSION_ROAS');
        const bodyItem3 = getHeadObj(headsMap, 'BROWSER_SESSION_ORDER_AMT');
        return (
          <VariousCell
            type="TRGT"
            bold
            item1={makeRowColumn(
              converCalFlagData('BROWSER_SESSION_ROAS', headsMap, rowObj),
              bodyItem1.type,
              bodyItem1.format
            )}
            item2={makeRowColumn(
              converCalFlagData('TRGT_BROWSER_SESSION_ROAS', headsMap, rowObj),
              bodyItem2.type,
              bodyItem2.format
            )}
            item3={makeRowColumn(
              rowObj['BROWSER_SESSION_ORDER_AMT'],
              bodyItem3.type,
              bodyItem3.format
            )}
          />
        );
      },
    },
    TRGT_BROWSER_SESSION_ROAS: { merged: true },
    BROWSER_SESSION_ORDER_AMT: { merged: true },
    SESSION_ROAS: {
      makeHead: (headsMap) => {
        return {
          content: (
            <InfoTitleArea
              title={t('테이블쇼핑타이틀', {
                label: getHeadObj(headsMap, 'SESSION_ORDER_AMT').label,
              })}
              tooltipTitle={t('테이블쇼핑툴팁SESSION_ORDER_AMT')}
              iconType="fainfoCircle"
            />
          ),
        };
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'SESSION_ROAS');
        const bodyItem2 = getHeadObj(headsMap, 'TRGT_SESSION_ROAS');
        const bodyItem3 = getHeadObj(headsMap, 'SESSION_ORDER_AMT');
        return (
          <VariousCell
            type="TRGT"
            bold
            item1={makeRowColumn(
              converCalFlagData('SESSION_ROAS', headsMap, rowObj),
              bodyItem1.type,
              bodyItem1.format
            )}
            item2={makeRowColumn(
              converCalFlagData('TRGT_SESSION_ROAS', headsMap, rowObj),
              bodyItem2.type,
              bodyItem2.format
            )}
            item3={makeRowColumn(
              rowObj['SESSION_ORDER_AMT'],
              bodyItem3.type,
              bodyItem3.format
            )}
          />
        );
      },
    },
    TRGT_SESSION_ROAS: { merged: true },
    SESSION_ORDER_AMT: { merged: true },
    DIRECT_ROAS: {
      makeHead: (headsMap) => {
        return {
          content: (
            <InfoTitleArea
              title={t('테이블쇼핑타이틀', {
                label: getHeadObj(headsMap, 'DIRECT_ORDER_AMT').label,
              })}
              tooltipTitle={t('테이블쇼핑툴팁DIRECT_ORDER_AMT')}
              iconType="fainfoCircle"
            />
          ),
        };
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'DIRECT_ROAS');
        const bodyItem2 = getHeadObj(headsMap, 'TRGT_DIRECT_ROAS');
        const bodyItem3 = getHeadObj(headsMap, 'DIRECT_ORDER_AMT');
        return (
          <VariousCell
            type="TRGT"
            bold
            item1={makeRowColumn(
              converCalFlagData('DIRECT_ROAS', headsMap, rowObj),
              bodyItem1.type,
              bodyItem1.format
            )}
            item2={makeRowColumn(
              converCalFlagData('TRGT_DIRECT_ROAS', headsMap, rowObj),
              bodyItem2.type,
              bodyItem2.format
            )}
            item3={makeRowColumn(
              rowObj['DIRECT_ORDER_AMT'],
              bodyItem3.type,
              bodyItem3.format
            )}
          />
        );
      },
    },
    TRGT_DIRECT_ROAS: { merged: true },
    DIRECT_ORDER_AMT: { merged: true },
    ROAS: {
      makeHead: (headsMap) => {
        return {
          content: (
            <InfoTitleArea
              title={t('테이블쇼핑타이틀', {
                label: getHeadObj(headsMap, 'ORDER_AMT').label,
              })}
              tooltipTitle={t('테이블쇼핑툴팁ORDER_AMT')}
              iconType="fainfoCircle"
            />
          ),
        };
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'ROAS');
        const bodyItem2 = getHeadObj(headsMap, 'TRGT_ROAS');
        const bodyItem3 = getHeadObj(headsMap, 'ORDER_AMT');
        return (
          <VariousCell
            type="TRGT"
            bold
            item1={makeRowColumn(
              converCalFlagData('ROAS', headsMap, rowObj),
              bodyItem1.type,
              bodyItem1.format
            )}
            item2={makeRowColumn(
              converCalFlagData('TRGT_ROAS', headsMap, rowObj),
              bodyItem2.type,
              bodyItem2.format
            )}
            item3={makeRowColumn(
              rowObj['ORDER_AMT'],
              bodyItem3.type,
              bodyItem3.format
            )}
          />
        );
      },
    },
    TRGT_ROAS: { merged: true },
    ORDER_AMT: { merged: true },
    PAR_EPRS_RATE: { merged: true },
  };

  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);
  const [tempParams, setTempParams] = useState(initParams);
  const [customized, setCustomized] = useState(initCustomized);
  const [openFlag, setOpenFlag] = useState(false);

  useEffect(() => {
    handleCustom(initParams);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    } // eslint-disable-next-line
  }, [initialization]);

  useEffect(() => {
    if (storeCommon.productCodeList.size > 0) {
      if (Object.keys(locationSearch).length > 0) {
        const converParams = conversionParams(
          storeCommon.productCodeList,
          locationSearch,
          storeAllProductCodeList
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
        initParams = { ...initParams, ...converParams };
        if (
          initParams.baseAddress === '/v2/media_report/ajax/ajaxBulkMediaMc.php'
        ) {
          delete initParams['mediaId'];
        }
        // if (
        //   initParams.baseAddress ===
        //     '/v2/openrtb/manage_openrtb_media_report.php' ||
        //   initParams.baseAddress === '/v2/openrtb/manage_openrtb_day_report.php'
        // ) {
        //   delete initParams['table'];
        // }
        if (initParams.baseAddress === '/v2/rtb_report/rtb_day_report.php') {
          // openRTB통계 - 카카오RTB - 일자별통계
          initParams['itlTpCode'] = '03';
        }
        setParams(initParams);
        setTempParams(initParams);
        setOpenFlag(true);
        handleCustom(initParams);
      }
    }
    // eslint-disable-next-line
  }, [storeAllProductCodeList]);

  const handleCustom = (propsParams = params) => {
    let newCustomized = { ...initCustomized };
    storeAllProductCodeList.forEach((value) => {
      const key = value['codeVal'];
      const parEprsCnt = key + '_PAR_EPRS_CNT';
      const parEprsRate = key + '_PAR_EPRS_RATE';
      newCustomized[key + '_PAR_EPRS_CNT'] = {
        makeHead: (headsMap) => {
          return value['label'];
        },
        makeBody: (rowObj, headsMap) => {
          const bodyItem1 = getHeadObj(headsMap, parEprsCnt);
          const bodyItem2 = getHeadObj(headsMap, parEprsRate);
          return (
            <>
              {makeRowColumn(
                rowObj[parEprsCnt],
                bodyItem1.type,
                bodyItem1.format
              )}
              (
              {makeRowColumn(
                rowObj[parEprsRate],
                bodyItem2.type,
                bodyItem2.format
              )}
              )
            </>
          );
        },
      };
      newCustomized[parEprsRate] = { merged: true };
    });
    setCustomized(newCustomized);
  };

  const getParam = () => {
    if (JSON.stringify(params) !== JSON.stringify(tempParams)) {
      setParams(tempParams);
      handleCustom(tempParams);
    }
  };
  const getTempParam = (newParams) => {
    if (JSON.stringify(tempParams) !== JSON.stringify(newParams)) {
      setTempParams(newParams);
    }
  };

  const addColumnList = (() => {
    const result = new Map();
    result.set(0, {
      id: 'MANAGE_ICONS',
      label: t('관리'),
      align: 'center',
      makeRowFunc: (data) => {
        return '';
      },
    });
    return result;
  })();

  return (
    openFlag && (
      <>
        <NewFilterWrap handleOnReset={undefined}>
          <NewCommonFilter
            initialization={initialization}
            params={tempParams}
            getParam={getTempParam}
            pltfomTpCodeDetailFilter={['03', '04']}
            usePltfomTpCodeFilter={
              params.baseAddress !== '/v2/rtb_report/rtb_day_report.php'
            }
          >
            {params.baseAddress === '/v2/rtb_report/rtb_day_report.php' && (
              <FilterCollection
                label={t('유형 구분')}
                name="pltfomTpCode"
                params={tempParams}
                value={tempParams.pltfomTpCode}
                type="radio"
                list={rtbDayPlatformList}
                callBack={getTempParam}
                labelKey="label"
                valueKey="value"
              />
            )}
          </NewCommonFilter>
          <NewButton type="filterButton" onClick={getParam} disableRipple>
            {t('검색')}
          </NewButton>
        </NewFilterWrap>
        <NewTableContainer
          params={params}
          getParam={getParam}
          dataReqPromise={adverDetailStatistics}
          customized={customized}
          useFetch={false}
          isIncludingTotal
          useTotalSubList
          reFetchHead
          rowsPerPage={100}
          useSearch={false}
          addColumnList={addColumnList}
        />
      </>
    )
  );
};

export default withRouter(DetailStatistics);
